import { Link } from "react-router-dom";

const GYP_LOGO = "/gyp-logo.png";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-ink text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto">
        
        {/* Main Footer */}
        <div className="grid md:grid-cols-12 border-b border-white/10">
          
          {/* Brand Column */}
          <div className="md:col-span-5 p-8 lg:p-12 border-r border-white/10">
            <div className="flex items-center gap-4 mb-6">
              <img
                src={GYP_LOGO}
                alt="GYP"
                className="h-12 w-12 object-contain logo-invert"
              />
              <div>
                <span className="font-serif text-xl block">Global Youth Platform</span>
                <span className="text-[10px] tracking-[0.2em] uppercase text-white/50">
                  International Organization
                </span>
              </div>
            </div>
            <p className="text-sm text-white/60 leading-relaxed max-w-sm">
              Developing future leaders through international diplomatic 
              programs and institutional partnerships since establishment.
            </p>
          </div>

          {/* Links Column */}
          <div className="md:col-span-3 p-8 lg:p-12 border-r border-white/10">
            <p className="text-[10px] tracking-[0.3em] uppercase text-white/40 mb-6">
              Navigation
            </p>
            <nav className="space-y-3">
              <a href="/#about" className="block text-sm text-white/70 hover:text-white transition-colors">
                About
              </a>
              <a href="/#programs" className="block text-sm text-white/70 hover:text-white transition-colors">
                Programs
              </a>
              <a href="/#partners" className="block text-sm text-white/70 hover:text-white transition-colors">
                Partners
              </a>
              <Link to="/team" className="block text-sm text-white/70 hover:text-white transition-colors">
                Team
              </Link>
              <Link to="/apply" className="block text-sm text-white/70 hover:text-white transition-colors">
                Apply
              </Link>
            </nav>
          </div>

          {/* Contact Column */}
          <div className="md:col-span-4 p-8 lg:p-12">
            <p className="text-[10px] tracking-[0.3em] uppercase text-white/40 mb-6">
              Contact
            </p>
            <div className="space-y-3 text-sm text-white/70">
              <p>info@globalyouthplatform.org</p>
              <p>globalyouthplatform.org</p>
              <p className="text-white/40">Global Operations</p>
            </div>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="px-8 lg:px-12 py-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-white/40">
            © {currentYear} Global Youth Platform. All rights reserved.
          </p>
          <div className="flex items-center gap-6 text-xs text-white/40">
            <a href="#" className="hover:text-white transition-colors">Privacy</a>
            <a href="#" className="hover:text-white transition-colors">Terms</a>
          </div>
        </div>

      </div>
    </footer>
  );
}
